//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ListSection from '~/components/landing/list_section'
import NewPopular from '~/components/coins/new_popular'
import global from '~/mixins/global'
import lists from '~/mixins/lists'
export default {
  name: 'Coins',
  components: { ListSection, NewPopular },
  mixins: [global, lists],
  async asyncData ({ store }) {
    await global.methods.getNewAndTrends(store, process.env.FAPI_URL, process.env.ASYNC_BASE_URL_API)
    await global.methods.getLoseAndGain(store, process.env.FAPI_URL, process.env.ASYNC_BASE_URL_API)
    // await store.dispatch('coins/getLoseAndGain')
    await store.dispatch('coins/getCoins')
  },
  data () {
    return {
      showVideo: false
    }
  },
  head () {
    return {
      title: this.$t('head.arzyptoCoins')
    }
  }
}
